import React from 'react'
import './Information.css'
function Information(props) {
    return (
        <div className='information_Container'>
             <div class="table-container">
              <table>
                <thead>
                  <tr className='headingRow'>
                    <th scope="col" className='rowSr'>Sr.</th>
                    <th scope="col">Name</th>
                    <th scope="col">Designation</th>
                    <th scope="col">Assigned</th>
                    <th scope="col">Completed</th>
                    <th scope="col">In Progress</th>
                    <th scope="col">Analytics</th>
                    <th scope="col">Update</th>
                  </tr>
                </thead>
                <tbody>
                  
                {props.info_Object.map((obj, index) => 
                  <tr key={index} className={`row${index+1}`}>
                    <td className='SrColumn'>{index+1}</td>
                    <td>
                      <div className='userProfile'>
                        <img src="/images/virat.png" className='userProfileImage'/>
                        <p>{obj.Name}</p>
                      </div>
                    </td>
                    <td>{obj.Designation}</td>
                    <td>{obj.Assigned}</td>
                    <td>{obj.Completed}</td>
                    <td>{obj.InProgress}</td>
                    <td>
                      <div className='analytics'>
                        <div className='ProgressRemaining'style={{width:`${100-obj.Analytics}%`}}>
                          <div className='Progress' style={{width:`${obj.Analytics}%`}}></div>
                        </div>
                      </div>
                    </td>
                    <td className='lastChange'>{`Last Changed ${obj.Update}h ago`}</td>
                  </tr>
                  
               )}

                </tbody>
              </table>
            </div>
        </div>
    )
}

export default Information
